<div class="policy-category staff">

  <div class="policy-item">

    <i class="policy-number">1</i>
    <radio-question [data]="authorsName.data" [valueSelected]="authorsName.valueSelected"
                    (selectAnswer)="onAuthorsNameSelected($event)"></radio-question>
    <br />
    <radio-question [data]="authorsNameFormat.data" [active]="authorsName.valueSelected === 'y'"
                    [valueSelected]="authorsNameFormat.valueSelected"
                    (selectAnswer)="onAuthorsNameFormatSelected($event)"></radio-question>
    <br />
    <div class="default-text" [innerHTML]="textCopy.appearNameTitle"></div>
    <input aria-label=""  class="app-input" type="text" [(ngModel)]="appearName"
           [disabled]="authorsName.valueSelected !== 'n'" />
    <br />
    <div class="default-text" [innerHTML]="textCopy.signatureTitle"></div>
    <input aria-label=""  class="app-input" type="text" [(ngModel)]="signature"
           [disabled]="authorsName.valueSelected !== 'n'" />
    <br />
    <radio-question [data]="singleLine.data" [valueSelected]="singleLine.valueSelected"
                    (selectAnswer)="onSingleLineSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <div class="default-text large" [innerHTML]="textCopy.needHelpTitle"></div>
    <br />
    <div class="default-text" [innerHTML]="textCopy.needHelpSubtitle"></div>
    <br />
    <div class="default-text" [innerHTML]="textCopy.expertDetailsTitle"></div>
    <div class="default-text" [innerHTML]="textCopy.userExpertTitle"></div>
    <table class="experts-table">
      <tr>
        <td class="default-text">name</td>
        <td><input aria-label=""  class="app-input" type="text" [(ngModel)]="userExpert.name" /></td>
      </tr>
      <tr>
        <td class="default-text">phone</td>
        <td><input aria-label=""  class="app-input" type="text" [(ngModel)]="userExpert.phone" /></td>
      </tr>
      <tr>
        <td class="default-text">mobile</td>
        <td><input aria-label=""  class="app-input" type="text" [(ngModel)]="userExpert.mobile" /></td>
      </tr>
      <tr>
        <td class="default-text">email</td>
        <td><input aria-label=""  class="app-input" type="text" [(ngModel)]="userExpert.email" /></td>
      </tr>
    </table>
    <br />
    <div class="default-text" [innerHTML]="textCopy.technicalExpertTitle"></div>
    <table class="experts-table">
      <tr>
        <td class="default-text">name</td>
        <td><input aria-label=""  class="app-input" type="text" [(ngModel)]="technicalExpert.name" /></td>
      </tr>
      <tr>
        <td class="default-text">phone</td>
        <td><input aria-label=""  class="app-input" type="text" [(ngModel)]="technicalExpert.phone" /></td>
      </tr>
      <tr>
        <td class="default-text">mobile</td>
        <td><input aria-label=""  class="app-input" type="text" [(ngModel)]="technicalExpert.mobile" /></td>
      </tr>
      <tr>
        <td class="default-text">email</td>
        <td><input aria-label=""  class="app-input" type="text" [(ngModel)]="technicalExpert.email" /></td>
      </tr>
    </table>
  </div>

  <div class="policy-item">
    <i class="policy-number">3</i>
    <div class="default-text large" [innerHTML]="textCopy.userDailyTargetTitle"></div>
    <div class="default-text" [innerHTML]="textCopy.userDailyTargetText"></div>
    <input aria-label=""  name="userDailyTarget" class="app-input" type="number" min="0" max="" [(ngModel)]="userDailyTarget" />
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
